import QRCode from 'react-native-qrcode-svg'

/**
 * Renders the scannable deposit QR from the EIP-681 URI produced by the
 * transfer hooks (e.g. `ethereum:0x…`). Built on `react-native-qrcode-svg`
 * (which renders via `react-native-svg`, already a peer for the CDN icons).
 *
 * The QR is always drawn as near-black (`#101010`, matching the Figma deposit
 * frame) modules on a white cell — fixed colors, NOT the Restyle theme: in dark
 * mode `textPrimary` is light, which over the light cell background renders
 * white-on-white (invisible/unscannable). QR contrast must hold regardless of
 * the app's color scheme.
 */
export interface QrCodeProps {
  /** The value to encode — the EIP-681 URI / address from `useTokenTransfer`. */
  value: string
  size?: number
  /**
   * Error-correction level. Defaults to `'H'` (highest) so the centered
   * chain-logo overlay ({@link QrChainCluster}) stays within scannable
   * tolerance.
   */
  ecl?: 'L' | 'M' | 'Q' | 'H'
}

export function QrCode({ value, size = 220, ecl = 'H' }: QrCodeProps) {
  return (
    <QRCode
      value={value}
      size={size}
      ecl={ecl}
      color="#101010"
      backgroundColor="#FFFFFF"
    />
  )
}
